<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<CRow>
			<CCol>
				<CRow>
					<CCol>
						<v-select
							:disabled="mode != mode_IMPORT1"
							v-model="afterSalesOrder.orderNumber"
							label="orderNumber"
							:options="orderNumber_options"
							@input="orderNumberSelect_change($event)"
							@search="orderNumberSelect_search"
							placeholder="Izberi št. DN">
							<template slot="no-options">Vnesite št. DN</template>
						</v-select>
					</CCol>
					<CCol class="col-auto pt-1">
						<CLink class="ml-2 pt-0" color="primary" title="Osveži podatke" @click.stop="importOrUpdateAfterSalesOrder(afterSalesOrder.orderNumber)">
							<CIcon name="cil-loop-circular"  size="lg"/>
						</CLink>
					</CCol>
				</CRow>
			</CCol>
		</CRow>
		<CRow v-if="mode === mode_UPDATE2" class="mt-2">
			<CCol>
				<CCard>
					<CCardHeader>
						JSON
					</CCardHeader>
					<CCardBody>
						<pre>{{ JSON.stringify(afterSalesOrder.fullJson, null, 2) }} </pre>
					</CCardBody>
				</CCard>
				
			</CCol>
		</CRow>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="onCancelModal()">Zapri</b-button>
						<b-button v-if="false" :disabled="okButton.disabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
	</b-modal>
</template>

<script>
import settings from '@/settings.js';
import imagesTool from '@/tools/images';
import _ from 'lodash';
import { SP_ORDER_NUMBER_EXTERNAL_SEARCH } from "@/store/actions/spOrders";
import { AFTER_SALES_ORDER_IMPORT_OR_UPDATE } from "@/store/actions/afterSalesOrders";


export default {
	name: 'replacement-vehicle-create-edit-modal',
	components: {
	},
	props: {
	},
	methods: {
		showModal: function (modalInput) {
			/*
				mode 1 => Import
				mode 2 => Update
			*/
			this.mode = modalInput.mode;
			this.initModal(modalInput.afterSalesOrder);
		},
		initModal: function (afterSalesOrder) {
			if (this.mode === this.mode_IMPORT1) {
				this.title = 'Uvoz delovnega naloga';
			} else if (this.mode === this.mode_UPDATE2) {
				this.initAfterSalesOrder(afterSalesOrder);
				this.title = 'Delovni nalog št. ' + this.afterSalesOrder.orderNumber;
			} else {
				this.mode = this.mode_UNKNOWN0;
				this.title = 'Neznan način';
			}
			this.okButton.label = 'Zapri';
			this.$refs.modal.show();
		},
		initAfterSalesOrder: function (afterSalesOrder) {
			this.afterSalesOrder.id = afterSalesOrder.id;
			this.afterSalesOrder.orderNumber = afterSalesOrder.order_number;
			this.afterSalesOrder.fullJson = JSON.parse(afterSalesOrder.full_json);
		},
		onCancelModal: function () {
			this.$refs.modal.hide();
		},
		clearModalData: function () {
			this.isLoading = false;
			this.title = '';
			this.okButton = {
				label: 'Shrani',
				progress: false,
				disabled: false
			};
			this.showAlert();
			this.mode = 0;
			this.resetAfterSalesOrderObject();
			this.orderNumber_options = [];
		},
		resetAfterSalesOrderObject: function () {
			this.afterSalesOrder.id = null;
			this.afterSalesOrder.orderNumber = '';
			this.afterSalesOrder.fullJson = '';
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		orderNumberSelect_load: _.debounce((loading, search, context) => {
			loading(true);
			context.$store.dispatch(SP_ORDER_NUMBER_EXTERNAL_SEARCH, search)
				.then((responseData) => {
					loading(false);
					context.orderNumber_options = responseData.items;
				})
				.catch(error => {
					loading(false);
					if(error.response && error.response.data && error.response.data.code) {
						context.showAlert('Napaka pri pridobivanju št. DN! (' + error.response.data.code + ')', context.ALERT_TYPE_ERROR);
					} else {
						context.showAlert('Napaka pri pridobivanju št. DN! Prosimo poizkusite kasneje.', context.ALERT_TYPE_ERROR);
					}
				});
		}, 500),
		orderNumberSelect_search: function (search, loading) {
			if (search && search !== '' && search.length >= this.motiondataConfig().orderNumberSearch.minInputLength) {
				this.orderNumberSelect_load(loading, search, this);
			}
		},
		orderNumberSelect_change: function (value) {
			if (value) {
				if (value.internalId) {
					this.importOrUpdateAfterSalesOrder(value.orderNumber);
				}
			}
		},
		importOrUpdateAfterSalesOrder: function (orderNumber) {
			this.startProgress();
			this.$store.dispatch(AFTER_SALES_ORDER_IMPORT_OR_UPDATE, { orderNumber })
				.then((responseData) => {
					this.stopProgress();
					this.afterSalesOrder.fullJson = JSON.parse(responseData.afterSalesOrder.full_json);
					this.$emit('emit_afterSalesOrderCreatedOrEdited', responseData);
					this.mode = this.mode_UPDATE2;
					this.showAlert();
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri pridobivanju naročila iz motiondata! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						} else {
						this.showAlert('Napaka pri pridobivanju naročila iz motiondata! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
	},
	data: function () {
		return {
			settings,
			imagesTool,
			isLoading: false,
			title: '',
			okButton: {
				label: 'Shrani',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_IMPORT1: 1,
			mode_UPDATE2: 2,
			mode: 0,
			afterSalesOrder: {
				id: null,
				orderNumber: '',
				fullJson: '',
			},
			orderNumber_options: [],
		}
	},
	watch: {
	},
	computed: {
		modalSize () {
			if (this.mode === this.mode_UPDATE2) return 'xl';
			return 'sm';
		},
		editingDisabled () {
			return false;
		},
	},
	created () {
	}
}
</script>

<style scoped>
.ma_pos {
	text-align: end;
}
</style>
<style>
</style>